import styled, { css } from 'styled-components';
import { colors, gradients, spacing, breakpoints } from '../../constants/theme';

export const Title = styled.h1<{ size?: 'sm' | 'md' | 'lg' | 'xl' }>`
  color: ${colors.text.primary};
  font-weight: 700;
  margin: 0 0 ${spacing.md} 0;
  
  ${props => {
    switch (props.size) {
      case 'sm':
        return css`
          font-size: 18px;
        `;
      case 'md':
        return css`
          font-size: 24px;
        `;
      case 'lg':
        return css`
          font-size: 32px;
        `;
      case 'xl':
        return css`
          font-size: 3rem;
          
          @media (max-width: ${breakpoints.tablet}) {
            font-size: 2.5rem;
          }

          @media (max-width: ${breakpoints.mobile}) {
            font-size: 2rem;
            line-height: 1.2;
          }
        `;
      default:
        return css`
          font-size: 24px;
        `;
    }
  }}
`;

export const Subtitle = styled.h2<{ size?: 'sm' | 'md' | 'lg' }>`
  color: ${colors.text.primary};
  font-weight: 600;
  margin: 0 0 ${spacing.sm} 0;
  
  ${props => {
    switch (props.size) {
      case 'sm':
        return css`
          font-size: 16px;
        `;
      case 'lg':
        return css`
          font-size: 24px;
          
          @media (max-width: ${breakpoints.tablet}) {
            font-size: 20px;
          }

          @media (max-width: ${breakpoints.mobile}) {
            font-size: 18px;
          }
        `;
      default:
        return css`
          font-size: 20px;
        `;
    }
  }}
`;

export const GradientTitle = styled(Title)`
  background: ${gradients.primary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const BodyText = styled.p<{ 
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'disabled';
}>`
  margin: 0;
  line-height: 1.6;
  
  color: ${props => {
    switch (props.variant) {
      case 'primary':
        return colors.text.primary;
      case 'disabled':
        return colors.text.disabled;
      default:
        return colors.text.secondary;
    }
  }};
  
  ${props => {
    switch (props.size) {
      case 'sm':
        return css`
          font-size: 14px;
        `;
      case 'lg':
        return css`
          font-size: 18px;
        `;
      default:
        return css`
          font-size: 16px;
        `;
    }
  }}
`;

export const Caption = styled.span<{ 
  variant?: 'primary' | 'secondary' | 'disabled' | 'hint';
}>`
  font-size: 12px;
  line-height: 1.4;
  
  color: ${props => {
    switch (props.variant) {
      case 'primary':
        return colors.text.primary;
      case 'secondary':
        return colors.text.secondary;
      case 'disabled':
        return colors.text.disabled;
      case 'hint':
        return colors.text.hint;
      default:
        return colors.text.secondary;
    }
  }};
`;

export const Label = styled.label<{ required?: boolean }>`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.text.primary};
  margin-bottom: ${spacing.sm};
  
  ${props => props.required && css`
    &::after {
      content: ' *';
      color: ${colors.error};
    }
  `}
`;

export const PageHeader = styled.div`
  margin-bottom: ${spacing.xl};
`;

export const SectionTitle = styled.h3<{ withDivider?: boolean }>`
  font-size: 18px;
  font-weight: 600;
  color: ${colors.text.primary};
  margin: 0 0 ${spacing.md} 0;
  
  ${props => props.withDivider && css`
    padding-bottom: ${spacing.md};
    border-bottom: 1px solid ${colors.background.tertiary};
    margin-bottom: ${spacing.lg};
  `}
`;

export const EmptyStateTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${colors.text.primary};
  margin: 0 0 ${spacing.md} 0;
`;

export const EmptyStateDescription = styled.p`
  font-size: 16px;
  color: ${colors.text.secondary};
  margin: 0;
  line-height: 1.6;
  max-width: 500px;
  margin: 0 auto;
`;
